<template>
  <span>
    <v-menu v-if="isChanged" v-model="isActive" offset-y allow-overflow top rounded absolute>
      <template #activator="{ on, attrs }">
        <v-btn
          class="btn my-2"
          :class="{ activeMenu: isActive }"
          color="secondary"
          outlined
          rounded
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('usermanagement.close') }}
        </v-btn>
      </template>
      <div class="pa-3 bg--white">
        <p class="error--text">{{ $t('usermanagement.close_warning') }}</p>
        <v-btn
          class="btn"
          color="secondary"
          :disabled="disabled"
          outlined
          rounded
          @click="$emit('close')"
        >
          {{ $t('usermanagement.close') }}
        </v-btn>
      </div>
    </v-menu>
    <v-btn
      v-else
      class="btn my-2"
      color="secondary"
      :disabled="disabled"
      outlined
      rounded
      @click="$emit('close')"
    >
      {{ $t('usermanagement.close') }}
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'CloseChangedButton',
  props: {
    isChanged: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
}
</script>

<style lang="scss" module>
:global(.activeMenu) {
  opacity: 0.2;
}
</style>
